module.exports = __webpack_public_path__ + "assets/img/Type E (33).3a5007d2.jpg";